import { Fragment } from "react";
import "./Features.scss";
import Accordion from "react-bootstrap/Accordion";

const Features = ({ para, dataList }) => {
  return (
    <section className="features p_bottom">
      <div className="content_wrap">
        <h2 className="wow fadeInUp">Features</h2>
        {para && <p>{para}</p>}

        <div className="acc_wrap">
          <Accordion>
            {dataList?.map((data, k) => {
              return (
                <Fragment key={data?._id}>
                  <Accordion.Item eventKey={`${k}`} className="wow fadeInUp">
                    <Accordion.Header>
                      <h2 className="plus">+</h2>
                      <h2 className="minus">-</h2>

                      <h3>{data?.title}</h3>
                    </Accordion.Header>
                    <Accordion.Body>
                      <div
                        className="danger"
                        dangerouslySetInnerHTML={{ __html: data?.content }}
                      ></div>
                    </Accordion.Body>
                  </Accordion.Item>
                </Fragment>
              );
            })}
          </Accordion>
        </div>
      </div>
    </section>
  );
};

export default Features;
